import { FunctionComponent, memo, useEffect, useMemo, useState } from "react";

interface IProps {
	points: {
		id: number,
		x: number,
		y: number,
	}[]
}

const pathD = (points: {
	x: number,
	y: number,
}[]) => {
	if (points.length < 2) { return "" };
	return `M ${points[0].x} ${points[0].y} ${points.slice(1).map(p => `L ${p.x} ${p.y}`).join(" ")}`;
}

const MouseLine: FunctionComponent<IProps> = (props) => {
	const { points } = props;

	const [t, setT] = useState(0);

	useEffect(() => {
		const move = () => {
			setT(t => t >= 1000 ? 0 : t + 50);
		}
		const timeout = setTimeout(move, 50);
		return () => {
			clearTimeout(timeout);
		}
	}, [t]);

	const date = new Date().getTime();

	return <svg version="1.1" id="L7" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" 
		x="0px" y="0px" height={"100%"} width={"100%"}>
		<g fillOpacity={0}>
			<path style={{ stroke: "var(--colorful-loading-blue)" }} strokeWidth={1} strokeLinecap="round" d={pathD(points.filter(c => c.id > date - 200))} />
		</g>
	</svg>;
}

export default memo(MouseLine);